export default {
  // START:: SET APP LOCALE
  setAppLocale(state, payload) {
    state.printable_admin_dashboard_printablege = payload;
  },
  // END:: SET APP LOCALE
};
